import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'return.returnReason',
        maxlength: 64,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    reasonCharacter: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'return.returnReasonCharacter',
        maxlength: 1,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    returnReasonCategoryID: {
      type: Select,
      props: {
        caption: 'return.returnReasonCategory',
        valueField: 'id',
        labelField: 'name',
        readonly: true,
        loading: vue.$store.getters['returnReasonCategory/isLoading'],
        options: vue.$store.getters['returnReasonCategory/loadedItems']
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
